export default __webpack_public_path__ + "static/media/captur-gallery-4.acd83ddf.jpg";